(function () {
  'use strict';

  var CARD_SELECTOR = 'hdt-card-product';

  function findPriceEl(card) {
    var selectors = [
      '.hdt-price__sale .hdt-money',
      '.hdt-price__regular .hdt-money',
      '.hdt-price .hdt-money',
      '.hdt-money',
      '[data-product-price]',
      '.hdt-pr-price'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = card.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function findCompareEl(card) {
    var selectors = [
      '.hdt-price__compare .hdt-money',
      '.hdt-price__was .hdt-money',
      '.hdt-price__compare',
      '[data-compare-price]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = card.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function findImg(card) {
    var selectors = [
      '.hdt-card-product__media .hdt-img img',
      '.hdt-card-product__media picture img',
      '.hdt-card-product__media img',
      '.hdt-card-product__wrapper img'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = card.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function initCard(card) {
    var selector = card.querySelector('.pf-variant-selector');
    if (!selector || selector.dataset.pfInited) return;
    selector.dataset.pfInited = 'true';

    var buttons = selector.querySelectorAll('.pf-variant-btn');

    buttons.forEach(function (btn) {
     btn.addEventListener('click', function (e) {

  if (btn.classList.contains('is-soldout')) return;

        /* 1. Active pill */
        buttons.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });

        var variantId        = btn.dataset.variantId;
        var priceFormatted   = btn.dataset.variantPriceFormatted;
        var compareFormatted = btn.dataset.variantCompareFormatted;
        var compareRaw       = parseInt(btn.dataset.variantCompare, 10) || 0;
        var priceRaw         = parseInt(btn.dataset.variantPrice, 10)   || 0;
        var available        = btn.dataset.variantAvailable === 'true';
        var imgSrc           = btn.dataset.variantImage;
        var imgSrc2x         = btn.dataset.variantImage2x;

        /* 2. Swap image */
        if (imgSrc) {
          var img = findImg(card);
          if (img) {
            img.src = imgSrc;
            img.srcset = imgSrc2x ? imgSrc + ' 1x, ' + imgSrc2x + ' 2x' : imgSrc;
            if ('src' in img.dataset)    img.dataset.src    = imgSrc;
            if ('srcset' in img.dataset) img.dataset.srcset = img.srcset;
          }
          card.querySelectorAll('.hdt-card-product__media source').forEach(function (src) {
            src.srcset = imgSrc2x ? imgSrc + ' 800w, ' + imgSrc2x + ' 1200w' : imgSrc;
          });
        }

        /* 3. Update price */
        var priceEl = findPriceEl(card);
        if (priceEl && priceFormatted) {
          priceEl.innerHTML = priceFormatted;
        }

        var compareEl = findCompareEl(card);
        if (compareEl) {
          if (compareRaw > priceRaw && compareFormatted) {
            compareEl.innerHTML = compareFormatted;
            compareEl.style.display = '';
            var cw = compareEl.closest('.hdt-price__compare, .hdt-price__was');
            if (cw) cw.style.display = '';
          } else {
            compareEl.innerHTML = '';
            compareEl.style.display = 'none';
            var cwh = compareEl.closest('.hdt-price__compare, .hdt-price__was');
            if (cwh) cwh.style.display = 'none';
          }
        }

        /* 4. Update variant input */
        var variantInput = card.querySelector('input[name="id"], select[name="id"]');
        if (variantInput) {
          variantInput.value = variantId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        /* 5. Update ATC button */
        var addBtn = card.querySelector('[data-atc],[data-product-atc],.hdt-btn-atc,.btn-atc,button[name="add"]');
        if (addBtn) {
          addBtn.disabled = !available;
          var soldOutText = (window.theme && window.theme.strings && window.theme.strings.soldOut) || 'Sold out';
          var addText     = (window.theme && window.theme.strings && window.theme.strings.addToCart) || 'Add to cart';
          var textNode = Array.from(addBtn.childNodes).find(function (n) {
            return n.nodeType === Node.TEXT_NODE && n.textContent.trim() !== '';
          });
          if (textNode) {
            textNode.textContent = ' ' + (available ? addText : soldOutText) + ' ';
          } else if (!addBtn.querySelector('svg, i, .icon')) {
            addBtn.textContent = available ? addText : soldOutText;
          }
        }

        /* 6. Fire HDT event */
        card.dispatchEvent(new CustomEvent('variant:change', {
          bubbles: true,
          detail: { variant: { id: parseInt(variantId, 10), price: priceRaw, available: available } }
        }));
      });
    });
  }

  function initAllCards() {
    document.querySelectorAll(CARD_SELECTOR).forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCards);
  } else {
    initAllCards();
  }

  ['collection:rerendered','pf:products:loaded','boost:render','searchie:render','facets:rendered','reinit'].forEach(function (evt) {
    document.addEventListener(evt, initAllCards);
  });

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName && node.tagName.toLowerCase() === CARD_SELECTOR) initCard(node);
        if (node.querySelectorAll) node.querySelectorAll(CARD_SELECTOR).forEach(initCard);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

})();